import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { GuidelineService } from 'shared/domain';

import { ComponentExpandStrategy, ComponentListWidget, ComponentWidget } from '@treetop/shared/model';

import { ComponentWidgetComponent } from './component/component-widget.component';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-component-list-widget',
  templateUrl: './component-list-widget.component.html',
  styleUrls: ['./component-list-widget.component.scss'],
  imports: [ComponentWidgetComponent],
})
export class ComponentListWidgetComponent {
  private guidelineService = inject(GuidelineService);

  public widget = input.required<ComponentListWidget>();
  protected componentWidgets = computed(() => {
    return this.widget().widgetIds?.map((widgetId) => this.guidelineService.getWidget<ComponentWidget>(widgetId));
  });

  public expandStrategy = input<ComponentExpandStrategy | null>(null);

  public allowEditTags = input<boolean>(false);

  public resolveMergeConflict = output();
  public unresolveMergeConflict = output();
}
